import { useMemo } from 'react';
import type { BreadcrumbProperties } from '../../breadcrumb';

type P = {
  breadcrumb?: BreadcrumbProperties;
};

export const useCreateBreadcrumbItems = ({ breadcrumb }: P) =>
  useMemo(() => {
    if (!breadcrumb?.items) {
      return undefined;
    }

    const paths = breadcrumb.items.map(({ path }) => path).filter((p): p is string => typeof p === 'string');

    return breadcrumb.items.map((route, index, routes) => ({
      key: route.key ?? route.path ?? index,
      title: breadcrumb.itemRender ? breadcrumb.itemRender(route, {}, routes, paths) : route.title,
    }));
  }, [breadcrumb]);
